import { Validator } from 'vee-validate';
import { validaTelefone } from '@/shared/common/functions/numero'

Validator.extend('telefone', {
   getMessage: 'Digite um telefone válido',
   validate: ((telefone) => {
       return validaTelefone(telefone)
   })
});